import { ximiUserManager } from './oidcConfig';

/** Header transportant la preuve SSO par requête vers StimulinAPI (users Ximi). */
export const XIMI_SSO_HEADER = 'X-Ximi-Sso-Token';

/** Access token SSO Xelya courant (null si aucune session ou session expirée). */
export async function getCurrentXimiSsoAccessToken(): Promise<string | null> {
    const user = await ximiUserManager.getUser();
    if (!user || user.expired) return null;
    return user.access_token ?? null;
}

// Renew partagé : N requêtes simultanées sur un token expiré = UNE seule tentative signinSilent.
let renewInFlight: Promise<string | null> | null = null;

/**
 * Token SSO frais : celui de la session s'il est valide, sinon une tentative de
 * silent renew (refresh token SSO). null = session SSO absente ou définitivement morte.
 */
export async function ensureFreshXimiSsoAccessToken(): Promise<string | null> {
    const current = await getCurrentXimiSsoAccessToken();
    if (current) return current;

    const user = await ximiUserManager.getUser();
    if (!user) return null; // pas de session SSO (user non-Ximi) — rien à renouveler

    if (!renewInFlight) {
        renewInFlight = ximiUserManager
            .signinSilent()
            .then((renewed) => renewed?.access_token ?? null)
            .catch(() => null)
            .finally(() => {
                renewInFlight = null;
            });
    }
    return renewInFlight;
}

/** Purge locale de la session SSO morte (sans end_session : elle est déjà invalide côté SSO). */
export async function clearXimiSsoSession(): Promise<void> {
    try {
        await ximiUserManager.removeUser();
    } catch {
        // purge best-effort — ne doit jamais bloquer le logout
    }
}
